import { GROUP_MAP, GROUP_TYPE } from '@/constants/entities'

export const ADMIN_PANEL_TAB_ID = {
  ORG_MEMBERS_TAB_ID: 'org-members',
  ORG_INVITATIONS_TAB_ID: 'org-invitations',
  GENERAL_TAB_ID: 'general',
  NOTIFICATION_TAB_ID: 'notifications',
  CHILD_ORGS_TAB_ID: 'child-orgs',
  TEAMS: 'teams',
  CUSTOM_FIELDS: 'custom-fields',
  BILLING_TAB_ID: 'billing',
  PLANS_TAB_ID: 'plans'
}
const childOrg = GROUP_MAP[GROUP_TYPE.CHILDORG].name
const team = GROUP_MAP[GROUP_TYPE.TEAM].name
export const PANEL_TABS = {
  GENERAL: {
    name: 'General',
    id: ADMIN_PANEL_TAB_ID.GENERAL_TAB_ID
  },
  NOTIFICATIONS: {
    name: 'Notifications',
    id: ADMIN_PANEL_TAB_ID.NOTIFICATION_TAB_ID
  },
  ORG_MEMBERS: {
    name: 'Org members',
    id: ADMIN_PANEL_TAB_ID.ORG_MEMBERS_TAB_ID
  },
  ORG_INVITATIONS: {
    name: 'Invitations',
    id: ADMIN_PANEL_TAB_ID.ORG_INVITATIONS_TAB_ID
  },
  CHILD_ORGS: {
    name: `${childOrg}s`,
    id: ADMIN_PANEL_TAB_ID.CHILD_ORGS_TAB_ID
  },
  TEAMS: {
    name: `${team}s`,
    id: ADMIN_PANEL_TAB_ID.TEAMS
  },
  CUSTOM_FIELDS: {
    name: 'Custom fields',
    id: ADMIN_PANEL_TAB_ID.CUSTOM_FIELDS
  },
  BILLING: {
    name: 'Billing',
    id: ADMIN_PANEL_TAB_ID.BILLING_TAB_ID
  },
  PLANS: {
    name: 'Plans',
    id: ADMIN_PANEL_TAB_ID.PLANS_TAB_ID
  }
}

export const RECURRENCE = {
  MONTH: 'month',
  YEAR: 'year'
}

export const RECURRENCE_LABEL = {
  [RECURRENCE.MONTH]: 'Monthly',
  [RECURRENCE.YEAR]: 'Yearly'
}
